export default {
  general: 'Ogólny',
  materialCalculationModels: 'Modele obliczeniowe materiałów',
  quenchingMediaSettings: 'Media gaśnicze',
};
